module.exports = __webpack_public_path__ + "img/logo-91.fa46f136.svg";